import React from 'react'
import PropTypes from 'prop-types'

function formatBirthdate(dateStr) {
  if (!dateStr) return null
  const d = new Date(dateStr + 'T00:00:00')
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

function StudentDuplicateWarning({ matches, onSelectStudent, onDismiss }) {
  if (!matches.length) return null

  return (
    <div className="mt-2 rounded-lg border border-amber-400 bg-amber-50 p-3">
      <p className="mb-2 text-xs font-semibold text-amber-800">
        {matches.length === 1
          ? 'A student with this name already exists at this facility'
          : 'Students with this name already exist at this facility'}
      </p>
      <div className="space-y-2">
        {matches.map((student) => (
          <div
            key={student.id}
            className="flex items-center justify-between rounded border border-amber-200 bg-white px-3 py-2"
          >
            <div>
              <p className="text-sm font-semibold text-gray-900">{student.full_name}</p>
              <p className="text-xs text-gray-500">
                {[
                  student.birthdate && `Born ${formatBirthdate(student.birthdate)}`,
                  student.skill_level
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </p>
            </div>
            <button
              type="button"
              onClick={() => onSelectStudent(student)}
              className="ml-3 rounded bg-amber-500 px-2.5 py-1 text-xs font-semibold text-white hover:bg-amber-600"
            >
              Use this student
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="mt-2 block w-full text-center text-xs text-amber-700 underline hover:text-amber-900"
      >
        Continue creating new student
      </button>
    </div>
  )
}

StudentDuplicateWarning.propTypes = {
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      full_name: PropTypes.string.isRequired,
      birthdate: PropTypes.string,
      skill_level: PropTypes.string
    })
  ).isRequired,
  onSelectStudent: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}

export default StudentDuplicateWarning
